import { render } from "./Cookies.vue?vue&type=template&id=4b649204&scoped=true"
const script = {}

import "./Cookies.vue?vue&type=style&index=0&id=4b649204&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4b649204"

export default script